import { buildCancellationPolicies, buildPartiallyRefundableCancellationPolicies } from '@luxuryescapes/lib-refunds'
import { mapBedbankBoardCode } from 'api/mappers/bedbankRateMap'
import { diffInDays } from 'lib/datetime/dateUtils'

/**
 * Builds a checkout BedbankRate from the enquiry session when the booked rate is
 * missing from bedbankOfferRates (e.g. availability vs public-offers supplier mismatch).
 */
export function buildBedbankRateFromEnquirySession(
  session: App.BedbankEnquiry,
  offer: App.BedbankOffer,
  item: App.Checkout.BedbankHotelItem,
): App.BedbankRate | undefined {
  if (!session.occupancyPricing?.length || !session.totals) {
    return undefined
  }

  const room = offer.packages.find(pkg => pkg.roomId === session.roomTypeId)
  if (!room) {
    return undefined
  }

  const nights = diffInDays(new Date(session.checkIn), new Date(session.checkOut))
  const cancellationPolicies = session.cancellationPolicies ?? []
  const timezone = offer.property.timezone
  const partiallyRefundable = session.partiallyRefundable ?? false

  return {
    id: session.roomRateId,
    roomId: session.roomTypeId,
    room,
    groupId: session.rateGroupId ?? undefined,
    promotionId: session.promotionId,
    bedGroups: session.bedGroups?.length
      ? session.bedGroups
      : [{ id: session.bedGroupId, description: '', configuration: [] }],
    occupancyPricing: session.occupancyPricing,
    totals: session.totals,
    cancellationPolicies,
    cancellationPolicy: partiallyRefundable
      ? buildPartiallyRefundableCancellationPolicies({
          checkIn: session.checkIn,
          checkOut: session.checkOut,
          policies: cancellationPolicies as any,
          nonRefundableDates: session.nonRefundableDateRanges ?? [],
        }, { timezone, midnightWrap: false } as any)
      : buildCancellationPolicies(cancellationPolicies as any, { timezone, midnightWrap: false } as any),
    refundable: session.refundable ?? item.refundable ?? false,
    partiallyRefundable,
    isFlightBundle: session.isFlightBundle,
    mobilePromotion: session.mobilePromotion,
    corporate: session.corporate ?? false,
    nights,
    supplierCode: session.supplierCode ?? '',
    supplier: session.supplier,
    boardCode: session.boardCode ?? (item.boardCode ? mapBedbankBoardCode(item.boardCode) : mapBedbankBoardCode('RO')),
    value: session.value ?? session.totals.inclusive,
    discount: session.discount ?? 0,
    memberDiscount: session.memberDiscount ?? 0,
    mx: session.mx,
    inclusions: session.inclusions ?? [],
    paymentScheduleInfo: session.paymentScheduleInfo,
  }
}
